import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { TelegramProvider } from './telegram-provider'
import { StateSync } from './state-sync'
import { routeTree } from './router/routeTree.gen'
import { AppErrorBoundary } from './error-boundary'

// Создаем Query Client с настройками по умолчанию
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 минут
      gcTime: 1000 * 60 * 10, // 10 минут (было cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Создаем роутер с scroll restoration
const router = createRouter({ 
  routeTree,
  // Сбрасывать скролл при навигации вперёд, восстанавливать при назад
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

// Расширяем типы для роутера
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export function App() {
  return (
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TelegramProvider>
          <StateSync />
          <RouterProvider router={router} />
        </TelegramProvider>
      </QueryClientProvider>
    </AppErrorBoundary>
  )
}

